<template>
	<div
		:class="[
			'field-wrap',
			'fieldgroup',
			fieldWrapClass,
			focused && 'focused',
			disabled && 'disabled',
			errorText ? 'error' : (warningText && 'warning'),
		]"
		tabindex="-1"
		@focus="focused = true"
		@blur="focused = false"
	>
		<label v-if="showLabel">
			<div class="flex items-center gap-1">

				<slot name="label">
					<span v-html="inputConfig[dataKey].label_trunc"></span>
				</slot>
				<Tooltip
					v-if="inputConfig[dataKey].definition"
					:title="inputConfig[dataKey].label"
					:description="inputConfig[dataKey].desc"
					>
					<p>
						{{ inputConfig[dataKey].definition }}
					</p>
				</Tooltip>
			</div>
		</label>

		<div :class="['row no-gutters', inputClass]">
			<input
				:type="type"
				:value="formData[dataKey]"
				:readonly="readOnly"
				:disabled="disabled"
				@input="handleInput"
				:step="step"
				:min="inputConfig[dataKey].AbsMin != null ? inputConfig[dataKey].AbsMin : undefined"
				:max="inputConfig[dataKey].AbsMax != null ? inputConfig[dataKey].AbsMax : undefined"
				@focus="focused = true"
				@blur="focused = false"
			/>

			<slot name="icon" />
		</div>

		<div class="suffix-wrap">

			<p class="locked"><slot name="locked-content"></slot></p>

			<p class="label-warning" v-if="warningText && !errorText">
				<WarningIcon />

				{{warningText}}
			</p>

			<p class="label-error">
				<ErrorIcon />

				{{errorText}}
			</p>
		</div>
	</div>
</template>

<script>
import Tooltip from "@/components/Tooltip"
import ErrorIcon from '@/components/ErrorIcon'
import WarningIcon from '@/components/WarningIcon'
import inputConfig from '@/components/FormInput/input-config'
import formData from '@/components/Sizer/form-data-store'
import sizerStore from '@/components/Sizer/sizer-store'

export default {
	name: 'FormInput',

	components: {
		Tooltip,
		ErrorIcon,
		WarningIcon,
	},

	props: {
		dataKey: String,
		type: {
			type: String,
			default: 'number',
		},
		step: {
			type: String,
			default: 'any',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		inputClass: {
			type: String,
			default: '',
		},
		fieldWrapClass: {
			type: String,
			default: '',
		},
		onInput: {
			type: Function,
			default: () => null
		},
		error: String,
	},

	data: () => ({
		formData,
		inputConfig,
		focused: false,
	}),

	computed: {
		errorText () {
			const { error, dataKey } = this
			const { errors } = sizerStore

			return error || errors && errors[dataKey]
		},

		warningText () {
			const { dataKey } = this
			const config = inputConfig[dataKey]
			if (!config) return null

			const value = formData[dataKey]
			if (value === '' || value === null || value === undefined) return null

			const num = Number(value)
			if (isNaN(num)) return null

			if (config.ExpMin != null && num < config.ExpMin && config.warningMin) {
				return config.warningMin
			}
			if (config.ExpMax != null && num > config.ExpMax && config.warningMax) {
				return config.warningMax
			}
			return null
		},

		showLabel () {
			const { $slots: { label }, dataKey } = this

			return label || inputConfig[dataKey].label_trunc
		}
	},

	methods: {
		handleInput ({ target: { value } }) {
			const { onInput, dataKey, type } = this
			const formattedValue = type === 'number' ? Number(value) : value;

			formData[dataKey] = formattedValue

			onInput(formattedValue)
		}
	}
}
</script>

<style>
.desc {
	display: flex;
	cursor:  pointer;
}

.suffix-icon-container {
	margin-left: -34px;
}

p.label-warning {
	background-color: #ffffff;
	padding: 2px 6px;
	border-radius: 3px;
	border: 1px solid #ED8408;
	z-index: 9999;
	position: absolute;
}
</style>
